// Created By - Vishnudas MV
// Date - 25-11-2025
// Pupose - Other Settings page - >Master settings ->General settings

import React, { useEffect, useState } from "react";
import CustomTable from "../../../../../../components/custom_table/CustomTable";

import "./ServiceCharges.css";
import {
  delete_serviceCharges_by_id,
  get_serviceCharges_list,
} from "../../../../../../api/generalSettingApis";
import CustomBottomPagination from "../../../../../../components/custom_bottom_pagination/CustomBottomPagination";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { BiEditAlt } from "react-icons/bi";
import { IconButton } from "@mui/material";
import { ErrorToast, SuccessToast } from "../../../../../../toast/toasts";
import { hasPrivilege } from "../../../../../../common_privilige_methods/Privilege_Methods";

import CustomDeleteConfirmModal from "../../../../../../components/custom_delete_confirm_modal/CustomDeleteConfirmModal";

import ServiceChargeForm from "./sub_pages/OtherSettingsForm";

function ServiceChargesSettings({ isSavePermission }) {
  const [serviceCharges_Modal, setServiceChargesModal] = useState(false);
  const [serviceChargesListing, setServiceChargesListing] = useState([]);

  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const [totalItemPerPage, setTotalItemPerPage] = useState(10);
  const [selectedItemId, setSelectedItemId] = useState(null);

  const [deleteConfirmation, setDeleteConfirmation] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const getServiceChargeList = (pageNumber, filterValue) => {
    const formData = new FormData();
    formData.append("page", pageNumber);
    formData.append("pageItem_count", totalItemPerPage);

    get_serviceCharges_list(formData)
      .then((response) => {
        setServiceChargesListing(response?.data?.data);
        setIsLoading(false);
        setTotalPages(response.data.data.last_page);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getServiceChargeList(pageNumber, totalItemPerPage);
  }, [pageNumber, selectedItemId]);

  const isPrivileges_Add = hasPrivilege(
    "Master Settings",
    "General Settings",
    "Add"
  );

  const isPrivileges_Edit = hasPrivilege(
    "Master Settings",
    "General Settings",
    "Edit"
  );

  // const isPrivileges_Delete = hasPrivilege(
  //   "Master Settings",
  //   "General Settings",
  //   "Delete"
  // );

  const Columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
    },
    {
      title: "Service Charge Name",
      dataIndex: "service_name",
      key: "service_name",
    },
    {
      title: "SAC Code",
      dataIndex: "sac_code",
      key: "sac_code",
    },
    {
      title: "GST Rate",
      dataIndex: "gst_rate",
      key: "gst_rate",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      wrapper: (row) => (
        <div>
          <p
            style={{
              color: row?.status == "Active" ? "#0A9E02" : "#FF0000",
          
            }}
          >
            {row?.status}
      
          </p>
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      action: (row) => (
        <div>
          {/* Edit Privilage needed */}
          {/* {isPrivileges_Edit && ( */}
          {isPrivileges_Add && (
            <IconButton
              onClick={() => {
                updateServiceChargesModal(true, row.id);
              }}
            >
              <BiEditAlt className="serviceChargess_edit" />
            </IconButton>
          )}

          {/* {isPrivileges_Delete && (
            <IconButton
              onClick={() => {
                handleDeleteModalClose(true, row.id);
              }}
            >
              <MdOutlineDeleteOutline className="serviceChargess_delete" />
            </IconButton>
          )} */}
        </div>
      ),
    },
  ];

  // Filter the columns dynamically when isSavePermission is true show all columns otherwise hide action

  // Edit Privilage needed
  // const visibleColumns = isPrivileges_Edit
  const visibleColumns = isPrivileges_Add
    ? Columns
    : Columns?.filter((column) => column.key !== "action");

  const updateServiceChargesModal = (state, selected_id) => {
    setServiceChargesModal(state);
    setSelectedItemId(selected_id);
    getServiceChargeList();
  };

  const handleDeleteModalClose = (state, selected_id) => {
    setDeleteConfirmation(state);
    setSelectedItemId(selected_id);
  };
  const updatePagination = (pageNumber) => {
    setPageNumber(pageNumber);
  };
  const updateItemPageCount = (pageItemCount) => {
    setTotalItemPerPage(pageItemCount);
  };
  const deleteserviceChargess = () => {
    if (selectedItemId) {
      delete_serviceCharges_by_id(selectedItemId)
        .then((response) => {
          handleDeleteModalClose(false);
          SuccessToast(response.data.message);
          get_serviceCharges_list(pageNumber, totalItemPerPage);
        })
        .catch((error) => {
          handleDeleteModalClose(false);
          ErrorToast(error?.data?.message);
        });
    }
  };
  const datas = () => {
    const result =
      serviceChargesListing &&
      serviceChargesListing.map((item, index) => {
        return {
          key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
          id: item?.id,
          service_name: item?.service_name,
          sac_code: item?.sac_code,
          gst_rate: item?.gst_rate,
          status:item?.status_name
        };
      });
    return result;
  };

  return (
    <div className="airline_module_main_container">
      <p className="locations_title">Service Charges Settings</p>
      <div className="airline_add_container ">
        {isPrivileges_Add && (
          <button
            className="airline_add_button"
            onClick={() => {
              updateServiceChargesModal(true);
            }}
          >
            Add New
          </button>
        )}
      </div>

      <CustomTable
        columns={visibleColumns}
        rows={datas()}
        loading={isLoading}
      />

      <div>
        <CustomBottomPagination
          total_items_per_page={totalItemPerPage}
          total_page_count={totalPages}
          current_page={pageNumber}
          on_change_value={updatePagination}
          on_page_count_update={updateItemPageCount}
        />
      </div>
      {serviceCharges_Modal ? (
        <ServiceChargeForm
          open={serviceCharges_Modal}
          handleClose={updateServiceChargesModal}
          serviceCharges_id={selectedItemId}
        />
      ) : (
        <></>
      )}
      {deleteConfirmation ? (
        <CustomDeleteConfirmModal
          module_name={"serviceChargess"}
          open_modal={deleteConfirmation}
          close_modal={handleDeleteModalClose}
          confirm_function={deleteserviceChargess}
        />
      ) : (
        <></>
      )}
    </div>
  );
}

export default ServiceChargesSettings;
